<template>

<main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />

        <section class="dp-contentblock block-columns">
            <div class="container grid lg:grid-cols-3 gap-16">
                <UCard class="card">
                    <template #header>
                        <NuxtPicture
                            src="BQ4C2038-1.jpg"
                            alt="Qualifizierter Spielplatzprüfer"
                            class="h-48 w-96 object-cover"
                            :img-attrs="{ class: 'rounded-lg' }"
                        />
                    </template>

                    <template #default>
                        <h3 class="column-title h3 mt-none mb-min">
                            Geprüfte Sicherheit
                        </h3>
                        <p class="column-teaser my-none">
                            Seit 2007 stellen wir unsere hohe fachliche Sicherheitskompetenz in der Beratung
                            unserer Kunden durch regelmäßige Zertifizierungen der DEULA Warendorf sicher.
                            Ihre zuständigen Berater/-innen sind somit „qualifizierte Spielplatzprüfer nach
                            DIN 79161“ oder „geprüfte Sachkundige für Spielplätze nach DIN EN 1176/7“.
                        </p>
                    </template>

                    <template #footer>
                            <a
                                class="button bordered flex! gap-2 justify-center items-center"
                                href="/pdf/Qualifizierter-Spielplatzpruefer.pdf"
                                target="_blank"
                            >
                                <IconDownload/>
                                Qualifizierter Spielplatzprüfer
                            </a>
                    </template>
                </UCard>

                <UCard class="card">
                    <template #header>
                        <NuxtPicture
                            src="BQ4C0483.jpg"
                            alt="AVPQ_Zertifikat"
                            class="h-48 w-96 object-cover"
                            :img-attrs="{ class: 'rounded-lg' }"
                        />
                    </template>

                    <template #default>
                        <h3 class="column-title h3 mt-none mb-min">
                            Unsere Präqualifikation
                        </h3>
                        <p class="column-teaser my-none">
                            Durch die jährliche Präqualifizierung im amtlichen Verzeichnis weisen wir nach,
                            dass unser Unternehmen für die von uns angebotenen Produkte und Dienstleistungen
                            qualifiziert ist.
                        </p>
                    </template>

                    <template #footer>
                        <a
                            class="button bordered flex! gap-2 justify-center items-center"
                            href="/pdf/AVPQ_Zertifikat-2026-2027.pdf"
                            target="_blank"
                        >
                            <IconDownload/>
                          AVPQ_Zertifikat 2026-2027 </a>
                    </template>
                </UCard>

                <UCard class="card">
                    <template #header>
                        <NuxtPicture
                            src="TUEV-Thueringen-GS.png"
                            alt="Fertigungsstättenzertifikat"
                            class="h-48 w-96 object-cover"
                            :img-attrs="{ class: 'rounded-lg' }"
                        />
                    </template>

                    <template #default>
                        <h3 class="column-title h3 mt-none mb-min">
                            GS Zertifizierung
                        </h3>
                        <p class="column-teaser my-none">
                            Mit der GS-Zertifizierung sorgen wir dafür, dass unsere Spielgeräte nicht nur langlebig und robust sind, sondern auch die Freude am Spielen mit einem sicheren Gefühl verbinden. So können Eltern, Kinder und Einrichtungen gleichermaßen vertrauen: Spielen bei uns bedeutet Spaß mit Sicherheit.
                        </p>
                    </template>

                    <template #footer>
                        <a
                            class="button bordered flex! gap-2 justify-center items-center"
                            href="/pdf/fertigungsstaettenzertifikat-2026.pdf"
                            target="_blank"
                        >
                            <IconDownload/>
                          <div>Fertigungsstättenzertifikat 2026</div>
                        </a>
                    </template>
                </UCard>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import IconDownload from '~/components/Icons/IconDownload.vue';

definePageMeta({
    path: '/Service/Zertifizierung',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Geborgenheit',
};

const sectionIntro = {
    images: ['BQ4C0119-1.jpg'],
    title: 'Zertifizierung',
    teaser: 'Was liegt Ihnen am Herzen, wenn Sie die richtigen Hersteller für Kinderspielgeräte suchen?',
    text: '<p>Sicherlich spielen da viele Faktoren eine wichtige Rolle! Wir bieten Ihnen anhand qualifizierter Ansprechpartner und zertifizierter Herstellung die Sicherheit um das Spielen aller Kinder sorgenfrei zu gestalten.</p>',
};
</script>

<style scoped>

</style>
